module.exports = __webpack_public_path__ + "img/Sesame seeds.65c083b6.png";